export const SIFT_SDK_URL = "https://cdn.sift.com/s.js";
